import React from "react";
import styles from "./document-checklist.module.scss";

type DocumentChecklistProps = {
  isExternal: boolean;
  onContinue: () => void;
};

const INTERNAL_DOCUMENTS = [
  "Letter of Employment",
  "Last 6 months’ pay slips",
  "Evidence of additional income (for the last 12 months, where applicable)",
  "Bank account statement (for the last 12 months)",
  "Valid means of identification (NIN, Voter’s Card or International Passport)",
];

const EXTERNAL_DOCUMENTS = [
  "Letter of Employment",
  "Last 6 months’ pay slips",
  "Evidence of additional income (for the last 12 months, where applicable)",
  "Bank account statement (for the last 12 months)",
  "Copy of the property’s title documents",
  "Seller’s Offer & Acceptance Letter",
  "Valid means of identification (NIN, Voter’s Card or International Passport)",
  "Clear Photos of the property",
];

const DocumentChecklist = ({ isExternal, onContinue }: DocumentChecklistProps) => {
  const documents = isExternal ? EXTERNAL_DOCUMENTS : INTERNAL_DOCUMENTS;

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconWrap}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z"
              stroke="#0D600D"
              strokeWidth="1.6"
              strokeLinejoin="round"
            />
            <path
              d="M14 2v6h6"
              stroke="#0D600D"
              strokeWidth="1.6"
              strokeLinejoin="round"
            />
            <path
              d="m8.5 13.5 2 2 4.5-4.5"
              stroke="#0D600D"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h1 className={styles.title}>Get Your Documents Ready</h1>

        <p className={styles.paragraph}>
          To make your mortgage application quick and seamless, please have
          the following documents available before you begin your
          application:
        </p>

        <ul className={styles.list}>
          {documents.map((doc) => (
            <li key={doc} className={styles.listItem}>
              <span className={styles.checkIcon}>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.5 6.2 4.8 8.5 9.5 3.5"
                    stroke="#fff"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span>{doc}</span>
            </li>
          ))}
        </ul>

        <p className={styles.note}>
          Please ensure all documents are clear, valid and readily available
          for upload during your application.
        </p>
        <p className={styles.note}>
          Having these documents ready will help us process your application
          more efficiently.
        </p>

        <button
          type="button"
          className={styles.continueBtn}
          onClick={onContinue}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default DocumentChecklist;
